module.exports = __webpack_public_path__ + "static/img/car_t.09c55d8c.png";